/* eslint-disable import/order */
/* eslint-disable import/first */
// import './src/why-did-you-render'; // uncomment to diagnose re-render issues

// anything that must run first before everything else
import './src/styles';
import 'react-native-reanimated';
import 'react-native-get-random-values';

// DO NOT MOVE THESE LINES for some reason web requires this or it bombs on local storage calls.
import Cognito from './src/utils/cognito/storage';
Cognito.getItem('FAKE');

import { updateId } from 'expo-updates';
import { enableFreeze, enableScreens } from 'react-native-screens';
import { initLaunchDarklyPromise } from './src/state/launchdarkly/launchdarkly-core';
import { appVersion, binaryRuntimeAppVersionWithBuildNumber } from './src/utils/app-version-info';
import { getCrashlytics, recordError, setAttribute } from './src/utils/crashlytics';
import { initDatadog } from './src/utils/datadog';
import { getDeviceIdAsync } from './src/utils/device-id';
import { appStartId } from './src/utils/environment';
import { setupGlobalErrorHandler } from './src/utils/fatal-error-handler';

const crashlytics = getCrashlytics();

const setCrashlyticsAttributes = () => {
  setAttribute(crashlytics, 'binaryRuntimeVersion', binaryRuntimeAppVersionWithBuildNumber);
  setAttribute(crashlytics, 'appVersion', appVersion);
  setAttribute(crashlytics, 'updateId', updateId ?? 'UNKNOWN');
  setAttribute(crashlytics, 'appStartId', appStartId);
};

// SETUP datadog logging
try {
  try {
    initDatadog();
  } catch (error) {
    setCrashlyticsAttributes();
    recordError(crashlytics, new Error(`Failed to init datadog logging! ${error?.toString()}`));
  }
} catch (error) {}

void initLaunchDarklyPromise;

// SETUP crashlytics
try {
  setCrashlyticsAttributes();
  getDeviceIdAsync().then(deviceId => setAttribute(crashlytics, 'deviceId', deviceId));
} catch (_error) {
  // ignore - never has fired and where would we log?
}

// SETUP global error handler
setupGlobalErrorHandler();

enableScreens(true);
enableFreeze(true);

// normal app start invokes src/app/_layout.tsx
// eslint-disable-next-line import/first
import 'expo-router/entry';
